import PropTypes from 'prop-types';

// Unity Image API valid crop modes:
export const IMAGE_CROP_MODES = {
  resizeScaleAndCrop: 'resizeScaleAndCrop',
  centerCrop: 'centerCrop',
  resizeScale: 'resizeScale',
  forceSize: 'forceSize',
  resizeScaleIfExceeded: 'resizeScaleIfExceeded',
  original: 'original'
};

// Unity Content Properties
export const CONTENT_PROPS = {
  contentType: PropTypes.oneOf(['EPISODE','MOVIE', 'SERIE', 'BROADCAST', 'SPORT']),
  description: PropTypes.string,
  duration: PropTypes.number,
  free: PropTypes.bool,
  id: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape({
    contentType: PropTypes.string,
    size: PropTypes.object,
    type: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })).isRequired,
  isNew: PropTypes.bool,
  live: PropTypes.bool,
  networks: PropTypes.arrayOf(PropTypes.shape({
    embed: PropTypes.bool,
    name: PropTypes.string.isRequired,
    network: PropTypes.string.isRequired
  })),
  title: PropTypes.string
};

export const CalendarIconPropTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
};


export const calendarIconDefault = {
  name: 'calendar-today',
  type: 'material-icons',
  color: 'white',
  size: 25,
};

export const ITEM_LABEL_PROPS = {
  time: 'time',
  network: 'network',
  none: 'none'
};

export const TEXT_MODES ={
    OUTER: 'outer',
    NONE: 'none',
    INNER: 'inner'
};